<template>
    <div
        class="backdrop-image"
        :style="{ '--backdrop-url': `url(${imageUrl})` }"
        aria-hidden="true"
    />
</template>

<script>
const DEFAULT_IMAGE = "/images/banners/trip-banner-1.jpg";

export default {
    name: "BackdropImage",
    props: {
        src: {
            type: String,
            default: null,
        },
    },
    computed: {
        imageUrl() {
            return this.src ?? DEFAULT_IMAGE;
        },
    },
};
</script>
